
import Layout from 'antd/lib/layout/layout';
import { useTranslation } from 'react-i18next';
import styles from './TestInvitationPage.module.less';
import { Loading3QuartersOutlined, CheckCircleFilled, CloseCircleFilled, WarningFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { AppDispatch } from 'redux/store';
import { useDispatch } from 'react-redux';
import { getProject } from 'redux/reducers/projectsSlice';
import { Project } from 'api';
import { useQuery } from 'utils/locationUtils';
import { acceptTestInvitation } from 'redux/reducers/testuserSlice';

export default function TestInvitationPage() {
  const { t } = useTranslation();;
  const query = useQuery();
  const invitationId = parseInt(query.get("id") ?? "");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingClass, setIsLoadingClass] = useState(styles.loadingIcon);
  const [completeIconClass, setCompleteIconClass] = useState(styles.successIcon);
  const [infoClass, setInfoClass] = useState(styles.infoLoaded);
  const [infoText, setInfoText] = useState(t('testInvitationPage.loading'));
  const [loadedInfoClass, setLoadedInfoClass] = useState(styles.loadingInfo);
  const [hasError, setHasError] = useState(false);
  const [alreadyAccepted, setAlreadyAccepted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(t('testInvitationPage.error'));
  const [errorSubtitle, setErrorSubtitle] = useState(t('testInvitationPage.error.subtitle'));
  const [subtitleText, setSubtitleText] = useState(t('testInvitationPage.finishedLoading.subtitle'))
  const dispatch: AppDispatch = useDispatch();
  const initializeFeedback = () => {
    setTimeout(() => {
      setIsLoadingClass(styles.doneLoadingIcon);
      setCompleteIconClass(styles.showSuccessIcon);
      setIsLoading(false);
      setInfoText(t('testInvitationPage.finishedLoading'))
      setInfoClass(styles.infoMissing)
      setLoadedInfoClass(styles.finishedLoadingInfo) 
    }, 2000)
  }
  useEffect(() => {
    
    dispatch(acceptTestInvitation(invitationId)).then((result) => {
      
      if(!acceptTestInvitation.fulfilled.match(result)){        
        
        if(result.error.message == "statusInvalid"){
          setAlreadyAccepted(true);          
          setSubtitleText(t('testInvitationPage.error.accepted.subtitle'))
          setInfoText(t('testInvitationPage.error.accepted'))
        }
        else{
          setSubtitleText(t('testInvitationPage.error.subtitle'))
          setInfoText(t('testInvitationPage.error'))
        }
        setLoadedInfoClass(styles.finishedLoadingInfo)
        setHasError(true);
        setIsLoading(false);
        setIsLoadingClass(styles.doneLoadingIcon);
        setInfoClass("h3 " + styles.infoLoaded)  
      }
      else{
        initializeFeedback();
      }      
      
    });
    
    

  }, []);
  return (
    <>

      <div className={styles.container}>
        <div className={styles.iconContainer}>
          <Loading3QuartersOutlined spin className={isLoadingClass} />
          <CheckCircleFilled className={completeIconClass} />
          <WarningFilled className={styles.warningIcon} style={{opacity: hasError && !alreadyAccepted ? 1 : 0}}/>
          <CloseCircleFilled className={styles.warningIcon} style={{opacity: alreadyAccepted ? 1 : 0}}/>
        </div>

        
        <div >
          <h1 className={"h3 " + " " + styles.finishedLoadingInfo + ' ' }>
            <b>{infoText}</b>
          </h1>
          <h3 className={"h3-subtitle " + styles.finishedLoadingInfo  + ' ' + loadedInfoClass}>
            {subtitleText}
          </h3>

        </div>
        
      </div>

    </>
  );

}